@if (template) {
    <div class="card panel-flat-color primary-panel flex-panel">
        <div class="panel-flat-header ws-flex-container-horizontal">
            <h3 class="ws-flex-auto ws-truncate">Valuation Template</h3>
            <div class="ws-flex-none header-button-container">
                @if (canEdit) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            (click)="upload()"
                            [disabled]="!canEnterEditMode"
                            helpTooltip
                            helpContentId="app.upload"
                            position="bottom">
                        <i class="fa fa-upload fa-align"></i>
                    </button>
                }
                @if (!isExpanded) {
                    <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="expandComponent()">
                        <i class="fa fa-arrows-alt"
                           helpTooltip
                           helpContentId="app.expand"
                           position="bottom"></i>
                    </button>
                }
                @if (isExpanded) {
                    <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="collapseComponent()">
                        <i class="fa fa-compress"
                           helpTooltip
                           helpContentId="app.collapse"
                           position="bottom"></i>
                    </button>
                }
            </div>
        </div>
        <div class="panel-flat-body ws-flex-container-vertical">
            @if (!template.hasFile || !template.siteClassPrimaries.length) {
                <div
                    class="ws-stretch ws-flex-container-horizontal ws-flex-align-items-center ws-flex-justify-content-center">
                    @if (template.siteClassPrimaries.length) {
                        <h4>The valuation doesn't have a template</h4>
                    }
                    @if (!template.siteClassPrimaries.length) {
                        <h4>Please select a primary site class to enable template upload</h4>
                    }
                </div>
            }
            @if (template && template.siteClassPrimaries.length && template.hasFile) {
                <table class="table table-condensed table-hover table-borderless">
                    <tbody>
                        <tr>
                            <td>
                                <span>{{ fileName }}</span>
                                @if (fileChangedBy && fileChangeDate) {
                                    <span>(Last changed by {{ fileChangedBy }}
                                        on {{ fileChangeDate | date: 'MM/dd/yyyy h:mm a' }})</span>
                                }
                            </td>
                            <td>
                                <div class="float-end">
                                    <button class="ace-btn has-icon btn-secondary"
                                            helpTooltip
                                            helpContentId="app.download"
                                            position="bottom"
                                            (click)="download()"
                                            [disabled]="!canEnterEditMode">
                                        <i class="fa fa-download fa-align"></i>
                                    </button>
                                    @if (canEdit) {
                                        <button
                                            class="ace-btn has-icon btn-primary btn-danger"
                                            helpTooltip
                                            helpContentId="app.delete"
                                            position="bottom"
                                            (click)="delete()"
                                            [disabled]="!canEnterEditMode">
                                            <i class="fa fa-trash fa-align"></i>
                                        </button>
                                    }
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            }
        </div>
    </div>
}
